import type { CheckboxData } from 'src/components/molecules/CheckboxGroup/CheckboxGroup';
import type { RadioButtonData } from 'src/components/molecules/RadioButtonGroup/RadioButtonGroup';

export const MIME_TYPES = [
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/svg+xml',
  'video/mpeg',
  'video/mp4',
  'video/ogg',
  'video/x-msvideo',
  'video/webm',
  'video/3gpp',
  'application/pdf',
];

export const LEADIN_TIME_OPTIONS: RadioButtonData<string>[] = [
  { labelText: 'Less than 1 month', value: 'LESS_THAN_ONE_MONTH' },
  { labelText: 'Less than 3 months', value: 'LESS_THAN_THREE_MONTHS' },
  { labelText: 'Over 3 months', value: 'MORE_THAN_THREE_MONTHS' },
];

export const YES_NO_OPTIONS: RadioButtonData<boolean>[] = [
  { labelText: 'Yes', value: true },
  { labelText: 'No', value: false },
];

export const SUPER_MARKETS_OPTIONS: CheckboxData[] = [
  { labelText: 'Tesco', value: 'TESCO' },
  { labelText: "Sainsbury's", value: 'SAINSBURYS' },
  { labelText: 'Asda', value: 'ASDA' },
  { labelText: 'Waitrose', value: 'WAITROSE' },
  { labelText: 'Marks & Spencer', value: 'M&S' },
  { labelText: 'Morrisons', value: 'MORRISONS' },
];

export const HIGH_STREET_STORES_OPTIONS: CheckboxData[] = [
  { labelText: 'John Lewis', value: 'JOHN-LEWIS' },
  { labelText: 'Debenhams', value: 'DEBENHAMS' },
  { labelText: 'House of Fraser', value: 'HOUSE_OF_FRASER' },
  { labelText: 'Paperchase', value: 'PAPERCHASE' },
  { labelText: 'Waterstones', value: 'WATERSTONES' },
  { labelText: 'Friends of Joules', value: 'FRIENDS_OF_JOULES' },
  { labelText: 'Next', value: 'NEXT' },
  { labelText: 'WHSmith', value: 'WHSMITH' },
];

interface OnlineStoreCheckboxData extends CheckboxData {
  id: string;
}

export const INITIAL_ONLINE_STORES_OPTIONS: OnlineStoreCheckboxData[] = [
  { id: 'aa422c21-bfa9-4342-8988-a977880ef16a', labelText: 'Etsy', value: 'ETSY' },
  { id: '7b3f4e2c-c305-4dd4-a252-cb7497d832ef', labelText: 'Amazon', value: 'AMAZON' },
  { id: 'cf6adf56-69f4-41df-a00f-82b8f9f8b35f', labelText: 'eBay', value: 'EBAY' },
  { id: '17c30467-862e-4d3b-bab1-bb67cd05c024', labelText: 'Moonpig', value: 'MOONPIG' },
  { id: 'b302dab2-e9f6-43c6-bc6b-433432339e5b', labelText: 'Wayfair', value: 'WAYFAIR' },
  { id: 'bbcf81c1-e606-4286-9cf3-c4c604eaa0f2', labelText: 'Funky Pigeon', value: 'FUNKY_PIGEON' },
  {
    id: '0e9057c2-b5fd-4712-b515-c87abb199b7f',
    labelText: 'Getting Personal',
    value: 'GETTING_PERSONAL',
  },
];
